import store from "../../store/store";

export default class Liveness{
    constructor() {
        this.$store = store;
    }
    carregarArquivos(){}
    preLoad(){}
    getRouteName(){}
    gerarID(){
        let date = new Date();
        return  btoa(`comp-selfie-${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`);
    }
}



// WEBPACK FOOTER //
// ./src/services/liveness/Liveness.js